import createReducer from '../createReducer';
import {TRealtimeAccount} from './realtimeAccount.type';

export const initialStateRealtimeAccount: TRealtimeAccount = {
    range: null,
    failedRange: null,
    revenue: null,
    transactions: null,
    tickets: null,
    conversion: null,
    getPackageSalesXHR: null
};

const reducer = createReducer('realtimeAccount', initialStateRealtimeAccount);

export default reducer;
